import { CallToAction } from "../_00Global/CallToAction";

export const _10CCTA = (): JSX.Element => {
  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="flex w-full justify-center items-center">
      <div className="flex flex-col w-[1440px] items-center justify-center relative">
        <CallToAction 
          className="!self-stretch !flex-[0_0_auto] !w-full" 
          largeButtonText="BACK TO TOP"
          onClick={handleBackToTop}
        />
      </div>
    </div>
  );
}; 